import config from '../config';

export function open({
  reference,
  amountInPesos,
  chatId,
}: {
  reference: string;
  amountInPesos: number;
  chatId: string;
}) {
  const checkout = new (<any>window).WidgetCheckout({
    currency: 'COP',
    amountInCents: amountInPesos * 100,
    reference,
    publicKey: config.wompiPubKey,
    redirectUrl: `https://api.hauscanner.com/v1/payment/${chatId}/callback`,
  });

  checkout.open(function (result: any) {
    var transaction = result.transaction;
    /*  console.log('Transaction ID: ', transaction.id);
    console.log('Transaction object: ', transaction); */
    window.location.href = `https://api.hauscanner.com/v1/payment/${chatId}/callback?id=${transaction.id}`;
  });
}

export function payPlan({
  userId,
  planId,
  amountInPesos,
}: {
  userId: string;
  amountInPesos: number;
  planId: string;
}) {
  const checkout = new (window as any).WidgetCheckout({
    currency: 'COP',
    amountInCents: amountInPesos * 100,
    reference: planId,
    publicKey: config.wompiPubKey,
    redirectUrl: `https://api.hauscanner.com/v1/payment/user/${userId}/callback`,
  });

  checkout.open(function (result: any) {
    var transaction = result.transaction;
    console.log('Transaction ID: ', transaction.id);
    console.log('Transaction object: ', transaction);
  });
}
